import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useSelectedCommunity from '../hooks/community/useSelectedCommunity';
import useSelectedBusiness from '../hooks/business/useSelectedBusiness';

export default function SelectedBusinessOrCommunityRoute(): ReactElement {
  const community = useSelectedCommunity();
  const business = useSelectedBusiness();

  // allow when either a selected community with dashboard exists OR a selected business with dashboard exists
  if ((community && community.dashboard) || (business && business.dashboard)) return <Outlet />;

  // otherwise redirect to landing
  return <Navigate to="/" />;
}
